import { copyAssignment as copyAssignmentAPI, fetchUserByID } from "../api";

export const copyAssignmentAction = async (assignmentID, userID, setAssignment, setUser) => {
  const assignment = await copyAssignmentAPI(assignmentID, userID);
  setAssignment(assignment.data);
  setUser((await fetchUserByID(userID)).data)
  return assignment.data;
};
